import PagedElements from '@/models/paged/pagedelements';
import MatrixTemplateListViewModel from '@/models/view/matrixtemplatelistviewmodel';

export default class PagedMatrixTemplates extends PagedElements<MatrixTemplateListViewModel> {
    constructor(init?: Partial<PagedMatrixTemplates>) { super(init); }
}
